import styled from 'styled-components';
import { spacing } from 'ui/theme';

import { MessageMedium } from 'constants/messageMediums';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { useEditSavedRowDesignContext } from '../context/EditSavedRowDesignContext';
import {
  CreativeLibraryButton,
  DetailsButton,
  LastSavedIndicator,
  PreferencesButton,
  SaveButtonCombo,
  SaveSavedRowDesignComboButton,
  SmsSmartOptInButton,
  SnippetButton,
} from './Controls';

// footer for Content editor

const ControlContainer = styled.div`
  align-items: center;
  display: flex;
  column-gap: ${spacing.threeEights};
  flex: 0 0 auto;
`;

const LeftContainer = styled.div`
  align-items: center;
  display: flex;
  column-gap: ${spacing.threeEights};
  flex: 1 1 auto;
`;

type Props = {
  showAssetBtn?: boolean;
  showPreferencesBtn: boolean;
  showSnippetBtn: boolean;
  showDetailsBtn?: boolean;
};

export const ContentFooter = ({
  showAssetBtn = false,
  showPreferencesBtn,
  showSnippetBtn,
  showDetailsBtn = true,
}: Props) => {
  const { selectedMessageMedium: medium } = useEditableFieldsContext();
  const { isEditingSavedRowDesign } = useEditSavedRowDesignContext();

  const showSmsSmartOptInBtn = medium === MessageMedium.Email || medium === MessageMedium.InApp;

  return (
    <>
      <LeftContainer>
        {showPreferencesBtn && <PreferencesButton />}
        {showSnippetBtn && <SnippetButton />}
        {showAssetBtn && <CreativeLibraryButton />}
        {showSmsSmartOptInBtn && <SmsSmartOptInButton />}
        {showDetailsBtn && <DetailsButton />}
      </LeftContainer>
      <ControlContainer>
        <LastSavedIndicator />
        {isEditingSavedRowDesign ? <SaveSavedRowDesignComboButton /> : <SaveButtonCombo />}
      </ControlContainer>
    </>
  );
};
